/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FontFamilyFromJSON, FontFamilyToJSON } from './FontFamily';
import { FontFamilyNullableFromJSON, FontFamilyNullableToJSON } from './FontFamilyNullable';
import { SiteSectionDocumentDocumentFromJSON, SiteSectionDocumentDocumentToJSON } from './SiteSectionDocumentDocument';
import { TextAlignmentFromJSON, TextAlignmentToJSON } from './TextAlignment';
import { TextAlignmentNullableFromJSON, TextAlignmentNullableToJSON } from './TextAlignmentNullable';
export function SiteSectionDocumentFromJSON(json) {
    return SiteSectionDocumentFromJSONTyped(json, false);
}
export function SiteSectionDocumentFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        sort: !exists(json, 'sort') ? undefined : json['sort'],
        displayTitle: !exists(json, 'display_title') ? undefined : json['display_title'],
        displayDescription: !exists(json, 'display_description') ? undefined : json['display_description'],
        presentationText: !exists(json, 'presentation_text') ? undefined : json['presentation_text'],
        descriptionAlignment: !exists(json, 'description_alignment')
            ? undefined
            : TextAlignmentNullableFromJSON(json['description_alignment']),
        descriptionFontFamily: !exists(json, 'description_font_family')
            ? undefined
            : FontFamilyNullableFromJSON(json['description_font_family']),
        descriptionFontSize: !exists(json, 'description_font_size') ? undefined : json['description_font_size'],
        descriptionTextColor: !exists(json, 'description_text_color') ? undefined : json['description_text_color'],
        displayDescriptionAlignment: !exists(json, 'display_description_alignment')
            ? undefined
            : TextAlignmentFromJSON(json['display_description_alignment']),
        displayDescriptionFontFamily: !exists(json, 'display_description_font_family')
            ? undefined
            : FontFamilyFromJSON(json['display_description_font_family']),
        displayDescriptionFontSize: !exists(json, 'display_description_font_size')
            ? undefined
            : json['display_description_font_size'],
        displayDescriptionTextColor: !exists(json, 'display_description_text_color')
            ? undefined
            : json['display_description_text_color'],
        createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
        updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at'],
        document: !exists(json, 'document') ? undefined : SiteSectionDocumentDocumentFromJSON(json['document'])
    };
}
export function SiteSectionDocumentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        sort: value.sort,
        display_title: value.displayTitle,
        display_description: value.displayDescription,
        presentation_text: value.presentationText,
        description_alignment: TextAlignmentNullableToJSON(value.descriptionAlignment),
        description_font_family: FontFamilyNullableToJSON(value.descriptionFontFamily),
        description_font_size: value.descriptionFontSize,
        description_text_color: value.descriptionTextColor,
        display_description_alignment: TextAlignmentToJSON(value.displayDescriptionAlignment),
        display_description_font_family: FontFamilyToJSON(value.displayDescriptionFontFamily),
        display_description_font_size: value.displayDescriptionFontSize,
        display_description_text_color: value.displayDescriptionTextColor,
        created_at: value.createdAt,
        updated_at: value.updatedAt,
        document: SiteSectionDocumentDocumentToJSON(value.document)
    };
}
